// Static projects data for portfolio
export const projectsData = [
  {
    id: 1,
    title: 'E-Commerce Platform (RazorKart)',
    description: 'A full-featured e-commerce platform with shopping cart, payment processing, and order management.',
    technologies: ['React', 'Node.js', 'MongoDB', 'Express'],
    image: '/static/profile-photos/proejct01.png',
    link: 'https://razorkart.vercel.app/',
    category: 'web',
    githubLink: 'https://github.com/LahiruDCode/RazorKart'
  },
  /*{
    id: 2,
    title: 'Task Management App',
    description: 'A task management application with drag-and-drop interface, real-time updates, and team collaboration features.',
    technologies: ['React', 'Firebase', 'Material-UI', 'Redux'],
    image: '/static/images/project2.jpg',
    link: 'https://example.com/task-manager',
    githubLink: 'https://github.com/yourusername/task-manager'
  },
  {
    id: 3,
    title: 'Real Estate Listing Website',
    description: 'A real estate platform allowing users to search properties, view details, and contact agents.',
    technologies: ['React', 'Node.js', 'MongoDB', 'Google Maps API'],
    image: '/static/images/project3.jpg',
    link: 'https://example.com/real-estate',
    githubLink: 'https://github.com/yourusername/real-estate'
  },
  {
    id: 4,
    title: 'Food Delivery App',
    description: 'A mobile-responsive food delivery application with restaurant listings, menu display, and order tracking.',
    technologies: ['React Native', 'Firebase', 'Redux', 'Stripe'],
    image: '/static/images/project4.jpg',
    link: 'https://example.com/food-delivery',
    githubLink: 'https://github.com/yourusername/food-delivery'
  },
  {
    id: 5,
    title: 'Portfolio Website',
    description: 'A modern portfolio website built with React and Tailwind CSS, featuring a responsive design and dark mode.',
    technologies: ['React', 'Tailwind CSS', 'Framer Motion'],
    image: '/static/images/project5.jpg',
    link: 'https://example.com/portfolio',
    githubLink: 'https://github.com/yourusername/portfolio'
  },
  {
    id: 6,
    title: 'Weather App',
    description: 'A weather application that provides current conditions and forecasts based on user location or search.',
    technologies: ['React', 'OpenWeather API', 'Chart.js', 'Geolocation API'],
    image: '/static/images/project6.jpg',
    link: 'https://example.com/weather-app',
    githubLink: 'https://github.com/yourusername/weather-app'
  },
  {
    id: 7,
    title: 'Portfolio Website',
    description: 'A modern portfolio website built with React and Tailwind CSS, featuring a responsive design and dark mode.',
    technologies: ['React', 'Tailwind CSS', 'Framer Motion'],
    image: '/static/images/project5.jpg',
    link: 'https://example.com/portfolio',
    githubLink: 'https://github.com/yourusername/portfolio'
  },
  {
    id: 8,
    title: 'Portfolio Website',
    description: 'A modern portfolio website built with React and Tailwind CSS, featuring a responsive design and dark mode.',
    technologies: ['React', 'Tailwind CSS', 'Framer Motion'],
    image: '/static/images/project5.jpg',
    link: 'https://example.com/portfolio',
    githubLink: 'https://github.com/yourusername/portfolio'
  },*/
];
